import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(
  (theme) => ({
    icon: {
      marginRight: theme.spacing(1),
      opacity: 0.9,
    },
  })
);
